/**
 * UI copy, HK Traditional Chinese.
 *
 * All user-facing strings live here so they can be reviewed and localised
 * without touching gameplay code.
 */
export const STRINGS = {
  title: 'ROLL BALL MAZE',
  subtitle: '滾球迷宮',

  /** On-screen control bar labels (touch / mobile). */
  controls: {
    left: '左轉',
    right: '右轉',
    restart: '重新開始',
    gyro: '陀螺儀',
    gyroOn: '陀螺儀：開',
    gyroOff: '陀螺儀：關',
    gyroUnsupported: '陀螺儀：不支援',
    portraitHint: '建議直向手持遊玩',
    begin: '開始',
  },

  /**
   * The marquee display, drawn over the machine's own LED panel.
   *
   * Three readouts, left to right, exactly as the design sheet lays them out:
   * the countdown/timer, the points this round, and the running total.
   */
  display: {
    countdown: '倒數',
    timer: '計時',
    round: '本回',
    total: '總分',
    /** Shown in the timer slot when there is no countdown and no live round. */
    idle: '--',
  },

  /** The diagnostic panel. Deliberately secondary to the marquee. */
  hud: {
    title: '診斷資訊',
    angle: '迷宮角度',
    ballSpeed: '球速',
    state: '狀態',
    round: '回合',
    score: '本回分數',
    totalScore: '總分',
    slot: '落點',
    held: '持球中',
  },

  hintsDesktop: [
    'A / D 或 ← / →　轉動迷宮',
    '按住滑鼠左右拖曳　轉動迷宮',
    'R　重新開始一局',
  ],
  hintsTouch: [
    '左右拖曳畫面　轉動迷宮',
    '按 ◀ ▶　轉動迷宮',
    '點「陀螺儀」後　傾斜手機操控',
    '按 ↻　重新開始一局',
  ],

  /** Shown in the 落點 row while the ball is still in play. */
  slotPending: '—',
  /** Shown when the ball never reached a pocket. */
  slotLost: '未入格',

  /** Ready / GameOver overlay copy. */
  flow: {
    readyBest: '最高分',
    overTotal: '總分',
    again: '再玩一次',
  },

  state: {
    loading: '載入中',
    ready: '準備',
    countdown: '倒數中',
    playing: '遊戲中',
    ballLost: '未入格',
    scored: '入格',
    gameOver: '遊戲結束',
  },

  bootError: '啟動失敗',
  /** Prefix for the asset-load failure banner. */
  assetError: '資產載入失敗',
} as const;

/** Map a game-state value onto its display label. */
export function stateLabel(state: string): string {
  return STRINGS.state[state as keyof typeof STRINGS.state] ?? state;
}
